// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const MoleratSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'molerat-idle',
    metadata: {
      frames: {
        'molerat-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-idle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-idle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-idle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/idle.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-idle': [
          'molerat-idle-0',
          'molerat-idle-1',
          'molerat-idle-2',
          'molerat-idle-3',
        ],
      },
    },
  },
  {
    name: 'molerat-walk',
    metadata: {
      frames: {
        'molerat-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-walk-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/walk.png',
        size: {
          w: 448,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-walk': [
          'molerat-walk-0',
          'molerat-walk-1',
          'molerat-walk-2',
          'molerat-walk-3',
          'molerat-walk-4',
          'molerat-walk-5',
          'molerat-walk-6',
        ],
      },
    },
  },
  {
    name: 'molerat-attack1',
    metadata: {
      frames: {
        'molerat-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-attack1-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-attack1-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-attack1-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/attack1.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-attack1': [
          'molerat-attack1-0',
          'molerat-attack1-1',
          'molerat-attack1-2',
          'molerat-attack1-3',
        ],
      },
    },
  },
  {
    name: 'molerat-rollStart',
    metadata: {
      frames: {
        'molerat-rollStart-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStart-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStart-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStart-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStart-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStart-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/rollStart.png',
        size: {
          w: 384,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-rollStart': [
          'molerat-rollStart-0',
          'molerat-rollStart-1',
          'molerat-rollStart-2',
          'molerat-rollStart-3',
          'molerat-rollStart-4',
          'molerat-rollStart-5',
        ],
      },
    },
  },
  {
    name: 'molerat-rollIdle',
    metadata: {
      frames: {
        'molerat-rollIdle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollIdle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollIdle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollIdle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/rollIdle.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-rollIdle': [
          'molerat-rollIdle-0',
          'molerat-rollIdle-1',
          'molerat-rollIdle-2',
          'molerat-rollIdle-3',
        ],
      },
    },
  },
  {
    name: 'molerat-rollStop',
    metadata: {
      frames: {
        'molerat-rollStop-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStop-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStop-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStop-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStop-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-rollStop-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/rollStop.png',
        size: {
          w: 384,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-rollStop': [
          'molerat-rollStop-0',
          'molerat-rollStop-1',
          'molerat-rollStop-2',
          'molerat-rollStop-3',
          'molerat-rollStop-4',
          'molerat-rollStop-5',
        ],
      },
    },
  },
  {
    name: 'molerat-hit',
    metadata: {
      frames: {
        'molerat-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-hit-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-hit-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-hit-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-hit-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/hit.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-hit': [
          'molerat-hit-0',
          'molerat-hit-1',
          'molerat-hit-2',
          'molerat-hit-3',
          'molerat-hit-4',
        ],
      },
    },
  },
  {
    name: 'molerat-dead',
    metadata: {
      frames: {
        'molerat-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-dead-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-dead-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-dead-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'molerat-dead-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/molerat/dead.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'molerat-dead': [
          'molerat-dead-0',
          'molerat-dead-1',
          'molerat-dead-2',
          'molerat-dead-3',
          'molerat-dead-4',
        ],
      },
    },
  },
];
